import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useSelector } from 'react-redux';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('layout_footer');

const Footer = () => {
    const companyName = useSelector((state: any) => state.BrandingConfiguration?.config?.companyName);
    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={6}>
                            {new Date().getFullYear()} © {companyName || st('he_thong_quan_ly_xo_so_text')}.
                        </Col>
                        <Col sm={6}>
                            <div className="text-sm-end d-none d-sm-block">
                                <small>{st('vtc_mobile_hint')}</small>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;
